<template>
    <div class="component">
        <div class="main-title">
            <div class="square"></div>
            <div class="title-content">成就</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TabAchievement",
        props: {
            componentData: [Object, Array]
        },
        methods: {},
        data() {
            return {};
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>

</style>
